import { useTranslation } from "react-i18next";
import "./Home.css";
import BannerCarousel from "../../components/BannerCarousel/BannerCarousel";

function Home() {
  const { t } = useTranslation();

  return (
    <main className="home">
      {/* Hero Banner Carousel */}
      <BannerCarousel />

      {/* Services */}
      <section className="services-section">
        <div className="section-container">
          <span className="section-label">{t("services.label")}</span>
          <h2 className="section-title">
            {t("services.title")}
          </h2>
          <p className="section-subtitle">
            {t("services.subtitle")}
          </p>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="#e85d2a">
                  <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
                </svg>
              </div>
              <h3>{t("services.express.title")}</h3>
              <p>
                {t("services.express.desc")}
              </p>
              <a href="/services" className="service-link">
                {t("services.learnMore")}
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="#e85d2a">
                  <path d="M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.05.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z" />
                </svg>
              </div>
              <h3>{t("services.sea.title")}</h3>
              <p>
                {t("services.sea.desc")}
              </p>
              <a href="/services" className="service-link">
                {t("services.learnMore")}
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="#e85d2a">
                  <path d="M19.15 8a2 2 0 00-1.72-1H15V5h-2v2H9V5H7v2H4.58a2 2 0 00-1.72 1L1 14v8h3.05c.5 1.14 1.62 2 2.95 2s2.45-.86 2.95-2h4.1c.5 1.14 1.62 2 2.95 2s2.45-.86 2.95-2H23v-8l-3.85-6zM7 22c-.83 0-1.5-.67-1.5-1.5S6.17 19 7 19s1.5.67 1.5 1.5S7.83 22 7 22zm10 0c-.83 0-1.5-.67-1.5-1.5S16.17 19 17 19s1.5.67 1.5 1.5S17.83 22 17 22zm4-5h-1.05c-.5-1.14-1.62-2-2.95-2s-2.45.86-2.95 2h-4.1c-.5-1.14-1.62-2-2.95-2s-2.45.86-2.95 2H3v-3h18v3z" />
                </svg>
              </div>
              <h3>{t("services.personal.title")}</h3>
              <p>
                {t("services.personal.desc")}
              </p>
              <a href="/services" className="service-link">
                {t("services.learnMore")}
              </a>
            </div>
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24" width="32" height="32" fill="#e85d2a">
                  <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-3-7h-2V9h-2v4H9l3 3 3-3z" />
                </svg>
              </div>
              <h3>{t("services.customs.title")}</h3>
              <p>
                {t("services.customs.desc")}
              </p>
              <a href="/services" className="service-link">
                {t("services.learnMore")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
